import { useState, useEffect } from "react"

export const useWindowDimensions = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== `undefined` ? window?.innerWidth : undefined
  )
  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    windowWidth,
    is_mobile: !!windowWidth ? windowWidth < 769 : undefined,
  }
}
